<template>
  <div >
    <products />
  </div>
</template>

<script>
export default {
  data () {
    return {
      site_name: localStorage.getItem("site_name")
    }
  },
}
</script>